<app-breadcrumb></app-breadcrumb>

<div class="card mb-0 mt-3">
    <div class="card-body">
        <div class="row">
            <div class="col-auto">
                <div class="input-group input-group-sm">
                    <input type="text" class="form-control" placeholder="검색어"
                        [(ngModel)]="searchValue"
                        (keyup.enter)="keyupEnterSearchValue($event)">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                            (click)="clickSearch()">
                            <i class="fas fa-search"></i>
                            <span class="ml-1">
                                검색
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                        <label class="input-group-text">
                            <i class="mdi mdi-file-tree"></i>
                            <span class="ml-1">
                                위험운전종류
                            </span>
                        </label>
                    </div>
                    <select class="form-control form-control-sm"
                        [(ngModel)]="selectedRuleType"
                        (ngModelChange)="changeRuleType($event)">
                        <option *ngFor="let item of listRuleType;" [ngValue]="item.dtgDriveRuleType">{{item.dtgDriveRuleTypeNm}}</option>
                    </select>
                </div>
            </div>
            <div class="col"></div>
        </div>

        <div class="table-responsive overflow-auto mt-3">
            <table class="table table-sm table-hover align-items-center text-nowrap mb-0">
                <thead>
                    <tr class="text-center">
                        <th>
                            차량번호
                        </th>
                        <th>
                            위험운전종류
                        </th>
                        <th>
                            운행시작
                        </th>
                        <th>
                            운행종료
                        </th>
                        <th>
                            상세
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of listItem;let idx = index;" class="text-center">
                        <td>
                            {{item.dtgCarNo}}
                        </td>
                        <td>
                            {{item.dtgDriveRuleTypeNm}}
                        </td>
                        <td>
                            {{item.dtgRegDtFrom}}
                        </td>
                        <td>
                            {{item.dtgRegDtTo}}
                        </td>
                        <td>
                            <button class="btn btn-sm btn-outline-secondary"
                                (click)="clickOpenModalDetail(DtgActionType.read,item)">
                                <i class="mdi mdi-pen"></i>
                                <span class="ml-1">상세</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="mt-3">
            <list-paging
                [inputPagingInfo]="pagingInfo"
                (callbackClickPageNumber)="callbackClickPageNumber($event)"
                (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
        </div>
    </div>
</div>